import React from "react";

export default function StopwatchClock({ elapsedSeconds, size = 250 }) {
  const center = size / 2;

  const hours = Math.floor(elapsedSeconds / 3600);
  const minutes = Math.floor((elapsedSeconds % 3600) / 60);
  const seconds = elapsedSeconds % 60;

  const hourDeg = (hours % 12) * 30 + minutes * 0.5;
  const minuteDeg = minutes * 6 + seconds * 0.1;
  const secondDeg = seconds * 6;

  const handStyle = (deg, length, thickness, color) => ({
    width: `${thickness}px`,
    height: `${length}px`,
    background: color,
    position: "absolute",
    top: `${center - length}px`,
    left: `${center - thickness / 2}px`,
    transformOrigin: `center ${length}px`,
    transform: `rotate(${deg}deg)`,
    borderRadius: "2px",
  });

  const clockStyle = {
    width: size,
    height: size,
    border: "4px solid #000",
    borderRadius: "50%",
    position: "relative",
    background: "#fff",
  };


  const ticks = [];
  for (let i = 0; i < 60; i++) {
    const angle = (i * 6 * Math.PI) / 180;
    const inner = i % 5 === 0 ? size * 0.40 : size * 0.43;
    const outer = size * 0.48;
    const x1 = center + inner * Math.sin(angle);
    const y1 = center - inner * Math.cos(angle);
    const x2 = center + outer * Math.sin(angle);
    const y2 = center - outer * Math.cos(angle);

    ticks.push(
      <line
        key={i}
        x1={x1}
        y1={y1}
        x2={x2}
        y2={y2}
        stroke="#000"
        strokeWidth={i % 5 === 0 ? 2 : 1}
      />
    );
  }

  const numbers = [];
  for (let i = 1; i <= 12; i++) {
    const angle = (i * 30 * Math.PI) / 180;
    const radius = size * 0.32;
    const x = center + radius * Math.sin(angle);
    const y = center - radius * Math.cos(angle);
    numbers.push(
      <text
        key={i}
        x={x}
        y={y + 6}
        textAnchor="middle"
        fontSize={size * 0.08}
        fontWeight="bold"
        fill="#000"
      >
        {i}
      </text>
    );
  }

  return (
    <div style={clockStyle}>
      {/* SVG layer for ticks + numbers */}
      <svg
        width={size}
        height={size}
        style={{ position: "absolute", top: 0, left: 0 }}
      >
        {ticks}
        {numbers}
      </svg>
      {/* Second hand */}
      <div style={handStyle(secondDeg, size * 0.45, 2, "green")} />

      {/* Center dot */}
      <div
        style={{
          width: "10px",
          height: "10px",
          background: "#000",
          borderRadius: "50%",
          position: "absolute",
          top: `${center - 5}px`,
          left: `${center - 5}px`,
          zIndex: 10,
        }}
      />
    </div>
  );
}
